import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=4478fdfb&scoped=true&"
import script from "./GoodsList.vue?vue&type=script&lang=js&"
export * from "./GoodsList.vue?vue&type=script&lang=js&"
import style0 from "./GoodsList.vue?vue&type=style&index=0&id=4478fdfb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4478fdfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4478fdfb')) {
      api.createRecord('4478fdfb', component.options)
    } else {
      api.reload('4478fdfb', component.options)
    }
    module.hot.accept("./GoodsList.vue?vue&type=template&id=4478fdfb&scoped=true&", function () {
      api.rerender('4478fdfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Goods/GoodsList.vue"
export default component.exports